import { Text } from "@chakra-ui/react";
import { ReactNode } from "react";
import { FormattedMessage } from "react-intl";

import { RanaModal } from "@nens/ranalib";

import { RouteBlockerFunction, useRouteBlocker } from "@/hooks/use-route-blocker";

export const RanaRouteBlocker = ({
  when,
  message,
}: {
  when: boolean | RouteBlockerFunction;
  message: ReactNode;
}) => {
  const { proceed, reset, state } = useRouteBlocker(when);

  if (state !== "blocked") return null;
  return (
    <RanaModal
      topBar={
        <FormattedMessage
          id="header.leave_page"
          defaultMessage="Do you really want to leave this page?"
        />
      }
      onClose={reset}
      buttons={[
        {
          children: <FormattedMessage id="common.cancel" defaultMessage="Cancel" />,
          variant: "secondary",
          onClick: reset,
        },
        {
          children: <FormattedMessage id="common.yes" defaultMessage="Yes" />,
          variant: "danger",
          onClick: proceed,
        },
      ]}
      isOpen
    >
      <Text>{message}</Text>
    </RanaModal>
  );
};
